/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/customer_service'
export default icon
